import {
  Component,
  h,
  Element,
  State,
  Prop,
  Listen,
  Method,
} from "@stencil/core"
import {
  AccordionState,
  AccordionActions,
  accordionReducer,
  getInitialState,
} from "../../accordion-store"
import {
  StoreConnection,
  StateHandle,
  closest,
  getAppearance,
} from "../../../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-accordion-item-header",
  styleUrl: "accordion-item-header.scss",
  shadow: true,
})
export class AccordionItemHeader {
  private store: StoreConnection<this, AccordionState, AccordionActions>

  @Element() public el!: HTMLSdxAccordionItemHeaderElement

  @State() public state!: StateHandle<AccordionState>

  /**
   * @private
   */
  @Prop() public buttonStyle: Record<string, string | undefined> = {}

  /**
   * @private
   */
  @Prop() public arrowStyle: Record<string, string | undefined> = {}

  @Listen("click")
  public onClick() {
    this.store.set("isUserInteractionInProgress", true)

    this.store.dispatch({
      type: "TOGGLE_ACCORDION_ITEM_EL",
      accordionItemEl: this.getParent(),
    })

    this.store.set("isUserInteractionInProgress", false)
  }

  /**
   * Closes this accordion item.
   */
  @Method()
  public async closeItem() {
    this.store.dispatch({
      type: "CLOSE_ACCORDION_ITEM_EL",
      accordionItemEl: this.getParent(),
    })
  }

  /**
   * Opens this accordion item.
   */
  @Method()
  public async openItem() {
    this.store.dispatch({
      type: "OPEN_ACCORDION_ITEM_EL",
      accordionItemEl: this.getParent(),
    })
  }

  constructor() {
    this.store = new StoreConnection(
      this,
      accordionReducer,
      getInitialState(),
      ["accordionItemEls", "openAccordionItemEls", "arrowPosition", "theme"],
    )
  }

  public componentDidLoad() {
    this.store.subscribe()
  }

  private getParent(): HTMLSdxAccordionItemElement {
    const { accordionItemEls } = this.state.get()

    return accordionItemEls.find((el) => closest(this.el, el))!
  }

  private isOpen(): boolean {
    const { openAccordionItemEls } = this.state.get()

    return openAccordionItemEls.some((el) => closest(this.el, el))
  }

  private getComponentClassNames() {
    const { arrowPosition, theme, accordionItemEls } = this.state.get()

    return {
      component: true,
      [getAppearance(this.el)]: true,
      open: this.isOpen(),
      [arrowPosition]: true,
      [theme]: true,
      "is-first-item": this.getParent() === accordionItemEls[0],
      "is-last-item":
        this.getParent() === accordionItemEls[accordionItemEls.length - 1],
    }
  }

  public render() {
    return (
      <button
        type="button"
        class={this.getComponentClassNames()}
        style={this.buttonStyle}
        aria-expanded={this.isOpen().toString()}
      >
        <div class="header">
          <slot />
        </div>

        <div class="arrow" style={this.arrowStyle}></div>
      </button>
    )
  }
}
